module.exports = __webpack_public_path__ + "static/media/certificate-icon.328dc0c1.svg";